var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMmrFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    viewBox: "0 0 60 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_59_62591)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H60V45H0V0Z",
    fill: "#FECB00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 15H60V45H0V15Z",
    fill: "#34B233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 30H60V45H0V30Z",
    fill: "#EA2839"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7724 7L35.7474 23.5834H25.7974L30.7724 7Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0259 36.9972L26.7485 20.6567L34.7982 26.5052L21.0259 36.9972Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 18.459L32.3091 18.852L29.2343 28.315L15 18.459Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.543 18.459L32.3086 28.315L29.2339 18.852L46.543 18.459Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5204 37.0001L26.748 26.5082L34.7978 20.6597L40.5204 37.0001Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_59_62591"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 45,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMmrFlag);
export default __webpack_public_path__ + "static/media/mmr-flag.f143ec7e7a03195f6a962aee3fa967b8.svg";
export { ForwardRef as ReactComponent };